<section class="section-qrcode" id="qrcode">

  <!-- ── Cabeçalho ── -->
  <div class="qrcode-header">
    <div class="qrcode-label anim">
      <!-- <h4>breakers</h4> -->
      <span class="qrcode-eyebrow">Conteúdo Exclusivo</span>
    </div>
    <h2 class="qrcode-title anim anim--delay-1">Páginas Ocultas</h2>
    <div class="qrcode-divider anim anim--delay-2"></div>
    <p class="qrcode-subtitle anim anim--delay-3">
      Dentro de capítulos específicos, segredos aguardam. <br>
      Uma nova maneira de ler livros, onde o conteúdo nunca termina. E sua imersão também não.
    </p>
  </div>

  <!-- ── Corpo principal: cards + QR ── -->
  <div class="qrcode-body">

    <!-- Cards de features -->
    <div class="qrcode-features">

      <div class="feature-card anim anim--delay-1">
        <div class="feature-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
            <rect x="3" y="14" width="7" height="7" rx="1"/><circle cx="17.5" cy="17.5" r="2.5"/>
          </svg>
        </div>
        <div class="feature-text">
          <h3>Escaneie</h3>
          <p>Aponte a câmera do celular para qualquer QR Code encontrado nas páginas impressas.</p>
        </div>
      </div>

      <div class="feature-card anim anim--delay-2">
        <div class="feature-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z"/>
            <path d="M12 8v4l3 3"/>
          </svg>
        </div>
        <div class="feature-text">
          <h3>Descubra</h3>
          <p>Acesse páginas ocultas com artes conceituais, histórias extra e detalhes inéditos.</p>
        </div>
      </div>

      <div class="feature-card anim anim--delay-3">
        <div class="feature-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
        </div>
        <div class="feature-text">
          <h3>Aproveite</h3>
          <p>Uma experiência única que transforma completamente sua forma de ler.</p>
        </div>
      </div>

    </div>

    <!-- QR Code em destaque -->
    <div class="qrcode-spotlight anim anim--delay-2">
      <div class="qrcode-badge">Experimente agora</div>
      <div class="qrcode-visual-panel" aria-hidden="true">
        <div class="qrcode-visual-vignette"></div>
      </div>
      <div class="qrcode-frame">
        <div class="qrcode-corners"></div>
        <a href="https://sagabreakers.com.br/colecao/capitulo/introducao" target="_blank" rel="noopener noreferrer" aria-label="Escanear QR Code da introdução de Breakers">
          <img
            src="assets/images/qrcode-intro.png"
            alt="QR Code – Acesse a página oculta da introdução de Breakers"
            class="qrcode-image"
            loading="lazy"
          />
        </a>
      </div>
      <p class="qrcode-caption">
        Capítulo: <em>Introdução</em>
      </p>
    </div>

  </div>

</section>
